<template>
    <div class="download-container">
        <div class="download-body">
            <div class="image-container">
                <div class="section">
                    <img class="download-img lazyload" :data-src="require('@/assets/download_bg_tmp.jpg')" alt="download section 1" @click="handleDownload">
                </div>

                <div class="section last-section">
                    <div class="copyright">
                        Copyright © 2024 深圳市寻讯科技有限公司 版权所有 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer"> 粤ICP备2024291999号</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getDownload } from '@/utils/api/apis';
import 'lazysizes';
export default {
    name: 'DownloadPage',
    methods: {
        isIOS() {
            return /iPhone|iPad|iPod/i.test(navigator.userAgent);
        },
        async handleDownload() {
            try {
                const res = await getDownload();
                const { android, ios } = res.data;

                if (this.isIOS()) {
                    window.location.href = ios;
                } else {
                    window.location.href = android;
                }
            } catch (e) {
                this.$toast('下载失败：' + e);
                this.$errorLog('download_page/handleDownload', e)
            }
        }
    }
}
</script>

<style lang='scss' scoped>
.download-container {
    width: 100%;
    min-height: 100vh;
    // background-color: #fff;
    background-color: #2f69fb;
    overflow-x: hidden;
}

.download-body {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background-color: #fff;
}

.image-container {
    width: 100%;
    max-width: 100%;
    position: relative;
}

.section {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #333;
}
.last-section {
    position: relative;
    .copyright {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: 0px;
        text-align: center;
        font-size: 9px;
        height: 30px;
        color: #333;
        a {
            margin-left: 4px;
            color: #333;
            text-decoration: none;
        }
    }
}

.download-img {
    width: 100%;
    height: auto;
    display: block;
    -webkit-user-select: none;
    -webkit-user-drag: none;
    user-select: none;
    max-width: none;
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    .image-container {
        width: 100vw;
    }

    .section {
        width: 100vw;
    }

    .download-img {
        width: 100vw;
        object-fit: cover;
    }
}

@media screen and (max-width: 375px) {
    .image-container {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/content/mobile/download_page.vue